/// <reference path="WebService.ts" />

// Type alias for the completion callback function
type ConversationCompletionCallback = (result: any, error: string) => void;

interface WebService
{
    newConversation( completion: ConversationCompletionCallback ) : void;
    sendPrompt( conversationID:string, prompt:string, completion: ConversationCompletionCallback ) : void;
}

WebService.prototype.newConversation = function( completion: ConversationCompletionCallback ) 
{
    const url_str = this.insightsURL + "/schema/" + this.scheme + "/conversation";
    let r = new DLRequest ( url_str, {}, "POST" );
    r.execute( (json:any, error:string) => {
        completion(json["conversation"], error);
    } );
}

WebService.prototype.sendPrompt = function( conversationID:string, prompt:string, completion: ConversationCompletionCallback ) 
{
    let body = { "prompt":prompt };
    const url_str = this.insightsURL + "/schema/" + this.scheme + "/conversation/" + conversationID + "/message";
    let r = new DLRequest ( url_str, body, "POST" );
    r.execute( (json:any, error:string) => {
        completion(json["response"], error);
    } );
}            
        